import PaypalIcon from "../../../assets/icons/pay-pal.svg";
import { Col } from "reactstrap";
import { Link } from "react-router-dom";
import Linked from "./Linked";
import { PAYPAL_APP_ID } from '../../../data/integration-app';
import FeatureLock from '../../../components/FeatureLock/FeatureLock';
import { FEATURE_IDS } from '../../../constants/featureAccess';

const Paypal = ({connectedVenues}) => {
    return (
        <Col md="6" xxl="3" xl="4">
            <FeatureLock featureId={FEATURE_IDS.COLLECT_PAYMENTS}>
                <Link
                to="/integrations/paypal"
                className="int-col"
                >
                {connectedVenues.some(data => parseInt(data.app_id) === PAYPAL_APP_ID) && <Linked />}    
                <div className="img">
                    <img src={PaypalIcon} alt="Paypal Payment " />
                </div>
                <div className="text">
                    <h3>Paypal</h3>
                    <p>
                    Accept payments quickly and securely with PayPal using balance, cards, or bank accounts — trusted worldwide.
                    </p>
                </div>
                </Link>
            </FeatureLock>
        </Col>
    );
}

export default Paypal;
